export default {
  // Page titles
  'pages.tenant.store.title': 'Store Management',
  'pages.tenant.store.subtitle':
    'Manage tenant store information, address configuration, and business status',
  'pages.tenant.store.addTitle': 'Add Store',
  'pages.tenant.store.editTitle': 'Edit Store',

  // Buttons
  'pages.tenant.store.addStore': 'Add Store',
  'pages.tenant.store.export': 'Export',
  'pages.tenant.store.cancel': 'Cancel',
  'pages.tenant.store.save': 'Save',
  'pages.tenant.store.edit': 'Edit',

  // Messages
  'pages.tenant.store.message.exportDeveloping':
    'Export feature is under development...',
  'pages.tenant.store.exportFileName': 'Store List',
  'pages.tenant.store.message.exportSuccess': 'Exported successfully',
  'pages.tenant.store.message.exportFailed': 'Export failed',
  'pages.tenant.store.message.addSuccess': 'Added successfully',
  'pages.tenant.store.message.editSuccess': 'Updated successfully',

  // Search
  'pages.tenant.store.search.placeholder':
    'Search store name, store code, or manager name',

  // Table columns
  'pages.tenant.store.column.storeType': 'Store Type',
  'pages.tenant.store.column.storeId': 'Store ID',
  'pages.tenant.store.column.storeCode': 'Store Code',
  'pages.tenant.store.column.storeName': 'Store Name',
  'pages.tenant.store.column.tenant': 'Tenant',
  'pages.tenant.store.column.address': 'Address',
  'pages.tenant.store.column.contact': 'Manager / Phone',
  'pages.tenant.store.column.deviceCount': 'Devices',
  'pages.tenant.store.column.taxType': 'Tax Type',
  'pages.tenant.store.column.storeStatus': 'Store Status',
  'pages.tenant.store.column.createTime': 'Created Time',
  'pages.tenant.store.column.action': 'Action',

  // Select placeholders
  'pages.tenant.store.placeholder.selectStoreType': 'Select store type',
  'pages.tenant.store.placeholder.selectStoreStatus': 'Select store status',

  // Card titles
  'pages.tenant.store.card.storeInfo': 'Store Information',
  'pages.tenant.store.card.taxInfo': 'Tax Information (BIR Compliance)',
  'pages.tenant.store.card.serviceFee': 'Service Fee Configuration',
  'pages.tenant.store.card.localTax': 'Local Tax Configuration',
  'pages.tenant.store.card.brandConfig': 'Brand & Display Configuration',

  // Form - Store info
  'pages.tenant.store.form.tenant': 'Tenant',
  'pages.tenant.store.form.tenantPlaceholder': 'Select tenant',
  'pages.tenant.store.form.tenantRequired': 'Please select a tenant',
  'pages.tenant.store.form.storeName': 'Store Name',
  'pages.tenant.store.form.storeNameRequired': 'Please enter store name',
  'pages.tenant.store.form.storeType': 'Store Type',
  'pages.tenant.store.form.storeTypePlaceholder': 'Select store type',
  'pages.tenant.store.form.storeTypeRequired': 'Please select store type',
  'pages.tenant.store.form.area': 'Store Area',
  'pages.tenant.store.form.areaPlaceholder': 'Select area',
  'pages.tenant.store.form.areaRequired': 'Please select store area',
  'pages.tenant.store.form.storeStatus': 'Store Status',
  'pages.tenant.store.form.storeStatusPlaceholder': 'Select store status',
  'pages.tenant.store.form.storeStatusRequired': 'Please select store status',
  'pages.tenant.store.form.contactName': 'Manager Name',
  'pages.tenant.store.form.contactNameRequired': 'Please enter manager name',
  'pages.tenant.store.form.contactPhone': 'Manager Phone',
  'pages.tenant.store.form.contactPhoneRequired': 'Please enter manager phone',
  'pages.tenant.store.form.contactPhonePattern':
    'Please enter a valid Philippine mobile number',
  'pages.tenant.store.form.businessHours': 'Business Hours',
  'pages.tenant.store.form.businessHoursRequired':
    'Please select business hours',
  'pages.tenant.store.form.startTime': 'Start Time',
  'pages.tenant.store.form.endTime': 'End Time',
  'pages.tenant.store.form.address': 'Store Address',
  'pages.tenant.store.form.addressRequired': 'Please enter store address',

  // Form - Tax info
  'pages.tenant.store.form.companyName': 'Legal Company Name',
  'pages.tenant.store.form.tinNumber': 'TIN Number',
  'pages.tenant.store.form.taxType': 'Tax Type',
  'pages.tenant.store.form.taxTypePlaceholder': 'Select tax type',
  'pages.tenant.store.form.taxTypeRequired': 'Please select tax type',
  'pages.tenant.store.form.taxAddress': 'Tax Address',

  // Form - Service fee
  'pages.tenant.store.form.serviceFeeSwitch': 'Service Fee Rule Switch',
  'pages.tenant.store.form.enabled': 'Enabled',
  'pages.tenant.store.form.disabled': 'Disabled',
  'pages.tenant.store.form.serviceFeeType': 'Service Fee Type',
  'pages.tenant.store.form.percentageValue': 'Percentage Value',
  'pages.tenant.store.form.percentageValueRequired':
    'Please enter percentage value',
  'pages.tenant.store.form.percentageValueRange':
    'Percentage must be an integer between 1 and 99',
  'pages.tenant.store.form.transactionType': 'Service Fee Transaction Types',
  'pages.tenant.store.form.transactionTypeRequired':
    'Please select transaction types',
  'pages.tenant.store.form.serviceFeeHint':
    'Enable service fee to configure fee collection method',

  // Form - Local tax (added 2026-10-28, mirrors service fee; HQ-only, not exposed on tenant side)
  'pages.tenant.store.form.localTaxSwitch': 'Local Tax Rule Switch',
  'pages.tenant.store.form.localTaxType': 'Local Tax Type',
  'pages.tenant.store.form.localTaxTransactionType':
    'Local Tax Transaction Types',
  'pages.tenant.store.form.localTaxTransactionTypeRequired':
    'Please select local tax transaction types',
  'pages.tenant.store.form.localTaxHint':
    'Enable local tax to configure tax collection method',

  // Form - Brand config
  'pages.tenant.store.form.storeLogo': 'Store Logo',
  'pages.tenant.store.form.uploadLogo': 'Upload logo image file',
  'pages.tenant.store.form.logoHint':
    'Supports JPG, PNG formats, recommended size 200x200 pixels',
  'pages.tenant.store.form.secondaryScreen': 'Secondary Screen Config',

  // Common
  'pages.tenant.store.form.input': 'Please enter',
};
